import { render, staticRenderFns } from "./ItemsImageRecommend.vue?vue&type=template&id=71d99a4e&scoped=true"
import script from "./ItemsImageRecommend.vue?vue&type=script&lang=js"
export * from "./ItemsImageRecommend.vue?vue&type=script&lang=js"
import style0 from "./ItemsImageRecommend.vue?vue&type=style&index=0&id=71d99a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d99a4e",
  null
  
)

export default component.exports